/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Tabby
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/Tabby/Query */
export class TabbyQuery {
    getWidgetPdp() {
        return new Field('getTabbyWidgetPdp')
            .addFieldList([
                'script_url',
                'selector',
                'merchantCode',
                'publicKey',
                'source',
                'currency',
                'currencyRate',
                'theme',
                'productType',
                'error'
            ]);
    }
}

export default new TabbyQuery();
